import React from 'react';
import ActivityFiltersNav from './activity-filters-nav/activity-filters-nav';
import AttendeesSearch from './attendess-search/attendess-search';

const AttendeesNavbar = (): JSX.Element => (
  <div className='attendees-navbar'>
    <div className='attendees-navbar_search'>
      <h4>Attendees</h4>
      <AttendeesSearch/>
    </div>
    <ActivityFiltersNav/>
  </div>
);

export default AttendeesNavbar;